import React, { useState } from 'react';
import { Car } from '../entities/car.entities';
import { exportToCSV, exportToJSON } from '../utils/exportUtils';
import { RequestBody } from '../services/api';

interface ExportButtonProps {
    currentPageData: Car[];
    totalCount: number;
    requestBody: RequestBody;
    onExportAll: (format: 'csv' | 'json') => void;
}

const ExportButton: React.FC<ExportButtonProps> = ({ currentPageData, totalCount, requestBody, onExportAll }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleExportShown = (format: 'csv' | 'json') => {
        const timestamp = new Date().toISOString().split('T')[0];
        const filename = `car-insurance-shown-${timestamp}.${format}`;

        if (format === 'csv') {
            exportToCSV(currentPageData, filename);
        } else {
            exportToJSON(currentPageData, filename);
        }

        setIsOpen(false);
    };

    const handleExportAll = (format: 'csv' | 'json') => {
        onExportAll(format);
        setIsOpen(false);
    };

    return (
        <div className="export-button-container">
            <button
                className="main-button"
                onClick={() => setIsOpen(!isOpen)}
                title="Export Data"
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
            </button>

            {isOpen && (
                <div className="export-dropdown">
                    <div className="export-section">
                        <div className="export-section-title">Shown Data ({currentPageData.length} records)</div>
                        <button
                            className="export-option"
                            onClick={() => handleExportShown('csv')}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                            </svg>
                            CSV
                        </button>
                        <button
                            className="export-option"
                            onClick={() => handleExportShown('json')}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                            </svg>
                            JSON
                        </button>
                    </div>
                    <div className="export-section">
                        <div className="export-section-title">All Filtered Data ({totalCount} records)</div>
                        <button
                            className="export-option"
                            onClick={() => handleExportAll('csv')}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                            </svg>
                            CSV
                        </button>
                        <button
                            className="export-option"
                            onClick={() => handleExportAll('json')}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                            </svg>
                            JSON
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExportButton;
